import * as indexedDBService from './indexedDBService';

export const updateNotificationStatus = async (
  notificationId: string,
  status: 'completed' | 'pending',
  newDueDate?: Date
) => {
  try {
    const notification = await indexedDBService.getItemById<any>('notifications', notificationId);

    if (notification) {
      const updateData = {
        ...notification,
        status,
        updatedAt: new Date().toISOString(), // Use string format for IDB consistency
      };

      if (newDueDate) {
        updateData.dueDate = newDueDate.toISOString();
      }

      await indexedDBService.putItem('notifications', updateData);
    }
  } catch (error) {
    console.error('Error updating notification status:', error);
    throw error;
  }
}; 
